import { render, staticRenderFns } from "./SidUploadImage.vue?vue&type=template&id=5ae0168e"
import script from "./SidUploadImage.vue?vue&type=script&lang=js"
export * from "./SidUploadImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports